import { injectable } from 'inversify';
import {
  club_status,
  type federation_club_category_dto,
  federation_club_dto,
  federation_club_full,
  type federation_club_website_dto,
} from '@Api';
import { Club, ClubCategory, ClubStatus, ClubWebsite } from '@Models';

@injectable()
export class ClubMapper {
  public map(item: federation_club_full): Club {
    return {
      id: item.id,
      name: item.name,
      notes: item.notes,
      location: item.location,
      latitude: item.latitude,
      longitude: item.longitude,
      contact: item.contact,
      members: item.members,
      meets: item.meets,
      country: item.country,
      status: this.mapStatus(item.status),
      websites: item.websites.map((website) => {
        return {
          id: website.id,
          link: website.link,
          isDeleted: false,
        } satisfies ClubWebsite as ClubWebsite;
      }),
      categories: item.categories.map((category) => {
        return {
          id: category.id,
          categoryId: category.category_id,
          name: category.category_name,
          isDeleted: false,
        } satisfies ClubCategory as ClubCategory;
      }),
    } satisfies Club as Club;
  }

  public mapStatus(item: club_status): ClubStatus {
    switch (item) {
      case club_status.DELETED:
        return ClubStatus.deleted;
      case club_status.INACTIVE:
        return ClubStatus.inactive;
      case club_status.ACTIVE:
        return ClubStatus.active;
    }
    return ClubStatus.pending;
  }

  public mapStatusDto(item: ClubStatus): club_status {
    switch (item) {
      case ClubStatus.deleted:
        return club_status.DELETED;
      case ClubStatus.inactive:
        return club_status.INACTIVE;
      case ClubStatus.active:
        return club_status.ACTIVE;
    }
    return club_status.PENDING;
  }

  public mapToDto(item: Club): federation_club_dto {
    return {
      name: item.name,
      notes: item.notes,
      country: item.country,
      location: item.location,
      contact: item.contact,
      members: item.members,
      meets: item.meets,
      status: this.mapStatusDto(item.status),
      club_websites_attributes: item.websites.map(
        (website) =>
          ({
            id: website.id,
            link: website.link,
            _destroy: website.isDeleted,
          }) satisfies federation_club_website_dto as federation_club_website_dto,
      ),
      club_categories_attributes: item.categories.map(
        (category) =>
          ({
            id: category.id,
            category_id: category.categoryId,
            _destroy: category.isDeleted,
          }) satisfies federation_club_category_dto as federation_club_category_dto,
      ),
    } satisfies federation_club_dto as federation_club_dto;
  }
}
